import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import RouterView from "@/views/RouterView.vue";
import AdviceView from "@/views/AdviceView.vue";
import PageView from "@/views/PageView.vue";
import NewsView from "@/views/NewsView.vue";
import AllNewsView from "@/views/AllNewsView.vue";
import HomeView from "@/views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/:lang(en|de|fr|it)?",
		component: RouterView,
		children: [
			{
				name: "home",
				path: "",
				component: HomeView,
			},
			{
				name: "all-news",
				path: "news",
				component: AllNewsView,
				props: true,
			},
			{
				name: "page",
				path: ":slug",
				component: PageView,
				props: true,
			},
			{
				name: "news",
				path: "news/:slug",
				component: NewsView,
				props: true,
			},

			{
				name: "advice",
				path: "advice/:slug",
				component: AdviceView,
				props: true,
			},
		],
	},
];

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior(to, from) {
		if (to.name === from.name && to.name !== "home") {
			return { x: 0, y: 0 };
		}

		return new Promise((resolve) => {
			setTimeout(() => {
				resolve({ x: 0, y: 0 });
			}, 700);
		});
	},
});

router.beforeEach((to, from, next) => {
	const lang = to.params.lang || store.state.site.defaultLanguage;
	// TODO add check is language exist if not then move to home page
	// if (!["en", "de"].includes(lang)) return next("de");

	console.log("update router");

	store.dispatch("site/setLanguage", lang);
	store.dispatch("site/setSlug", to.fullPath);
	store.dispatch("page/getPage", { lang, path: to.fullPath });
	store.dispatch("site/setPage", to.name);
	store.dispatch("site/setFrom", from.name);

	return next();
});

export default router;
